import { getParentNode, isNodeShadowRoot } from '@datadog/browser-rum-core';
export function createNodeIds() {
    const nodeIds = new WeakMap();
    let nextNodeId = 1 /* NodeIdConstants.FIRST_ID */;
    const get = (node) => nodeIds.get(node);
    return {
        assign: (node) => {
            // Try to reuse any existing id.
            let nodeId = get(node);
            if (nodeId === undefined) {
                nodeId = nextNodeId++;
                nodeIds.set(node, nodeId);
            }
            return nodeId;
        },
        get,
        areAssignedForNodeAndAncestors: (node) => {
            let current = node;
            while (current) {
                if (get(current) === undefined && !isNodeShadowRoot(current)) {
                    return false;
                }
                current = getParentNode(current);
            }
            return true;
        },
    };
}
//# sourceMappingURL=nodeIds.js.map